import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-equipo',
  templateUrl: './page-equipo.component.html',
  styleUrls: ['./page-equipo.component.scss']
})
export class PageEquipoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scroll(0,0);
  }

}
